import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const ventajas = [
  {
    icon: "ri-smartphone-line",
    title: "Comodidad",
    desc: "Sube o baja todas las persianas desde el sofá o la cama. Sin esfuerzo, sin manivela.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Seguridad",
    desc: "Simula presencia cerrando persianas automáticamente cuando no estás en casa.",
  },
  {
    icon: "ri-time-line",
    title: "Ahorro de tiempo",
    desc: "Programa horarios diarios. Las persianas se ajustan solas al amanecer y al atardecer.",
  },
  {
    icon: "ri-home-smile-line",
    title: "Domótica",
    desc: "Compatible con Alexa, Google Home y Somfy TaHoma. Controla con voz o desde el móvil.",
  },
];

const precios = [
  { servicio: "Motorización completa (persiana manual → eléctrica)", precio: "200 - 380 €" },
  { servicio: "Solo motor (instalación en persiana preparada)", precio: "150 - 250 €" },
  { servicio: "Mantenimiento anual", precio: "60 €" },
];

const domotica = [
  { name: "Alexa", desc: "Di 'Alexa, baja la persiana del salón' y listo." },
  { name: "Google Home", desc: "Compatible con comandos de voz de Google Assistant." },
  { name: "Somfy TaHoma", desc: "Centralita profesional para automatizar toda tu casa." },
];

const faqs = [
  {
    q: "¿Necesito instalación eléctrica especial?",
    a: "No en la mayoría de casos. Los motores actuales funcionan con corriente normal de 220V. Si tu persiana no tiene enchufe cercano, valoramos la instalación en la visita gratuita.",
  },
  {
    q: "¿Funciona sin luz?",
    a: "El motor necesita electricidad para funcionar, pero puedes bajarla manualmente en caso de corte. Algunos modelos llevan batería de emergencia opcional.",
  },
  {
    q: "¿Se puede controlar desde el móvil?",
    a: "Sí, con motores Somfy io o con centralitas TaHoma. Desde la app controlas todas las persianas de casa estés donde estés.",
  },
  {
    q: "¿Qué garantía tiene el motor?",
    a: "Todos nuestros motores llevan garantía de 2 años en piezas y mano de obra. Si falla, lo cambiamos sin coste.",
  },
  {
    q: "¿Es ruidoso?",
    a: "Los motores modernos Somfy y Cherubini son muy silenciosos. El ruido es mínimo, similar a un zumbido suave. Si tu motor actual hace mucho ruido, probablemente esté estropeado.",
  },
];

export default function PersianasElectricas() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Persianas Eléctricas Málaga | Motorización y Reparación"
        description="Persianas eléctricas en Málaga: instalación, reparación y motorización. Compatibles con domótica. Garantía 2 años. ☎ 951 12 07 70"
        canonical="/persianas/persianas-electricas/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Persianas", path: "/persianas" }, { name: "Persianas eléctricas" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> 24h · Respuesta en 20 min
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Persianas Eléctricas en Málaga: Instalación y Reparación
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Comodidad y modernidad. Motorizamos tu persiana manual o reparamos la existente.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> +10 años · desde 2015</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Seguro RC</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</span>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1631084650668-5e1f72bf6ce5?w=1200&q=80&auto=format&fit=crop"
                    alt="Persianas eléctricas en Málaga - instalación y reparación"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* VENTAJAS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Ventajas de las persianas eléctricas</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {ventajas.map((v, i) => (
                <motion.div
                  key={v.title}
                  className="bg-white rounded-[20px] p-8 border-t-[6px] border-primary shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${v.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{v.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{v.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* PRECIOS */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-4">¿Cuánto cuesta motorizar?</h2>
            <p className="font-body text-lg text-text-secondary text-center mb-10 max-w-2xl mx-auto">
              Precios orientativos. El coste exacto depende del tamaño de la persiana, la marca del motor y si necesitas instalación eléctrica adicional. Visita gratis sin compromiso.
            </p>
            <div className="max-w-2xl mx-auto bg-surface-alt rounded-3xl overflow-hidden">
              {precios.map((p, i) => (
                <div
                  key={p.servicio}
                  className={`flex items-center justify-between px-6 md:px-8 py-5 ${i !== precios.length - 1 ? "border-b border-border" : ""}`}
                >
                  <span className="font-body text-base md:text-lg text-text-primary">{p.servicio}</span>
                  <span className="font-heading font-bold text-lg md:text-xl text-primary">{p.precio}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* DOMÓTICA */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 items-start">
              <div className="w-full lg:w-1/2">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Compatibilidad domótica</h2>
                <p className="font-body text-lg text-text-secondary mb-6">
                  Conecta tus persianas eléctricas a tu sistema de casa inteligente. Controla con voz, desde el móvil o programa horarios automáticos.
                </p>
                <div className="flex flex-col gap-3">
                  {domotica.map((d, i) => (
                    <motion.div
                      key={d.name}
                      className="flex items-center gap-4 bg-white rounded-xl px-5 py-4 shadow-sm"
                      initial={{ opacity: 0, x: -15 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: i * 0.08 }}
                    >
                      <div className="w-10 h-10 bg-secondary/10 text-secondary rounded-lg flex items-center justify-center shrink-0">
                        <i className="ri-home-wifi-line text-xl"></i>
                      </div>
                      <div>
                        <div className="font-heading font-bold text-base text-text-primary">{d.name}</div>
                        <div className="font-body text-sm text-text-secondary">{d.desc}</div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <div className="bg-text-primary rounded-3xl p-8 md:p-10">
                  <h3 className="font-heading font-bold text-2xl text-white mb-6">¿Por qué motorizar?</h3>
                  <ul className="flex flex-col gap-4">
                    {[
                      "Sube y baja persianas sin moverte del sofá",
                      "Protege tu casa simulando presencia",
                      "Ahorra en calefacción regulando el sol",
                      "Ideal para ventanas altas o de difícil acceso",
                      "Aumenta el valor de tu vivienda",
                    ].map((item, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <span className="flex items-center justify-center w-6 h-6 bg-primary text-white rounded-full shrink-0 text-xs font-bold mt-0.5">✓</span>
                        <span className="font-body text-sm text-slate-300">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes sobre persianas eléctricas</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}